import React, { useState, useEffect } from 'react'
import intl from 'react-intl-universal'
import dayjs from 'dayjs'

import { Button, Space, Toast } from 'antd-mobile'

import { initOrderPayModal } from '../../../model/store'
import { getPayResultUrl } from '../../../utils/page'


function ButtonTool({ item, actions, loading, from = 'result' }) {
    const { doPayAction, showCancelWindow } = actions || {}
    const [timeLeft, setTimeLeft] = useState(null)
    const [showPaymentButton, setShowPaymentButton] = useState(true)
    const [payLoading, setPayLoading] = useState(false)

    // 计算剩余时间
    useEffect(() => {
        if (item?.orderTime) {
            const orderTime = dayjs(item.orderTime)
            const deadline = orderTime.add(30, 'minute')
            const now = dayjs()

            // 如果已经超过30分钟，直接隐藏按钮
            if (now.isAfter(deadline)) {
                setShowPaymentButton(false)
                return
            }

            // 计算剩余时间
            const remaining = deadline.diff(now, 'second')
            setTimeLeft(remaining)

            // 设置倒计时
            const timer = setInterval(() => {
                setTimeLeft(prev => {
                    if (prev <= 1) {
                        setShowPaymentButton(false)
                        clearInterval(timer)
                        return 0
                    }
                    return prev - 1
                })
            }, 1000)

            return () => clearInterval(timer)
        }
    }, [item?.orderTime])

    // 格式化剩余时间
    const formatTimeLeft = (seconds) => {
        if (seconds <= 0) return '00:00'
        const minutes = Math.floor(seconds / 60)
        const remainingSeconds = seconds % 60
        return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`
    }

    const toPayment = () => {
        const { orderId } = item
        const payData = {}
        const resultUrl = getPayResultUrl(orderId, from)
        setPayLoading(true)
        initOrderPayModal({
            orderId,
            partnerId: payData.partnerId,
            paymentMethod: payData.payMethod,
            returnUrl: resultUrl,
            cancelUrl: resultUrl + '&result=cancel',
        }).then(result => {
            console.log(result)

            const { dwz = {} ,context_data} = result
            const { urlVal } = dwz
            const payHref = urlVal || context_data


            if (payHref) {
                Toast.show({
                    icon: 'loading',
                    content: intl.get('redirect_pay').d('正在跳转支付，请稍后...')
                })
                //this.setState({ payUrl: urlVal, payVisible: true })
                window.location.href = payHref
            } else {
                Toast.show({
                    icon: 'fail',
                    content: intl.get('no_pay_info').d('没有支付相关信息')
                })
                setPayLoading(false)
            }

        }).catch(ex => {

            console.log(ex, '===init pay===fail')
            setPayLoading(false)
        })
    }

    return (
        <div className="text-center button m-b-sm">
            <Space wrap justify='center' direction='vertical'>

                {/* 支付按钮 */}
                {item.status === 2 && showPaymentButton && (
                    <>
                        <Button
                            color="warning"
                            // fill='outline'
                            size='small'
                            shape='rounded'
                            style={{ padding: '8px 50px' }}
                            loading={loading || payLoading}
                            onClick={() => {
                                if (doPayAction) {
                                    doPayAction(item.orderId)
                                } else {
                                    toPayment()
                                }
                            }}
                        >
                            {intl.get('payment').d('支付')}
                        </Button>
                        {/* 倒计时显示 */}
                        {timeLeft !== null && timeLeft > 0 && (
                            <div style={{
                                fontSize: '12px',
                                color: '#666',
                                marginBottom: '8px'
                            }}>
                                {intl.get('payment_time_limit').d('支付剩余时间')}: <span style={{ color: '#ff8f1f' }}>{formatTimeLeft(timeLeft)}</span>
                            </div>
                        )}
                    </>

                )}


                {/* 超时提示 */}
                {!showPaymentButton && item.status === 2 && (
                    <div style={{
                        fontSize: '12px',
                        color: '#ff4d4f',
                        padding: '8px 16px',
                        backgroundColor: '#fff2f0',
                        borderRadius: '6px',
                        border: '1px solid #ffccc7'
                    }}>
                        {intl.get('payment_timeout').d('支付超时，订单已失效')}
                    </div>
                )}
            </Space>
        </div>
    )
}

export default ButtonTool